import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';

import YumurtlamaImg from '../../assets/tupBebek.png';
import AsrmEshre from '../../components/asrmEshre';

export function TupBebek() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="tüp bebek tedavisi" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="tüp bebek tedavisi" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="image-wrapper">
            <img src={YumurtlamaImg} alt="Tüp Bebek Tedavisi" />
          </div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <h3><TranslateStatic string="tupbebekH3" /></h3>
            <p>
              <TranslateStatic string="tupbebekP1" />
            </p>

            <h3><TranslateStatic string="tupbebekH4" /></h3>
            <p>
              <TranslateStatic string="tupbebekP3" />
            </p>
            <p>
              <TranslateStatic string="tupbebekP4" />
            </p>

            <h3><TranslateStatic string="tupbebekH5" /></h3>
            <p>
              <TranslateStatic string="tupbebekP6" />
            </p>

            <h3><TranslateStatic string="tupbebekH6" /></h3>
            <p>
              <TranslateStatic string="tupbebekP7" />
            </p>

            <h3><TranslateStatic string="tupbebekH7" /></h3>
            
            <h4><TranslateStatic string="tupbebekH8" /></h4>
            <p>
              <TranslateStatic string="tupbebekP8" />
            </p>
            
            <h4><TranslateStatic string="tupbebekH9" /></h4>
            <p>
              <TranslateStatic string="tupbebekP9" />
            </p>
            
            <h4><TranslateStatic string="tupbebekH10" /></h4>
            <p>
              <TranslateStatic string="tupbebekP10" />
            </p>
            
            <h4><TranslateStatic string="tupbebekH11" /></h4>
            <p>
              <TranslateStatic string="tupbebekP11" />
            </p>
            
            <h4><TranslateStatic string="tupbebekH12" /></h4>
            <p>
              <TranslateStatic string="tupbebekP12" />
            </p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
